// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"619":"d444a6f0","692":"cea61094","871":"0e31e5cc"}[chunkId] + ".chunk.css";
};